import React from "react";
import { LoadingProvider } from "./src/context/LoadingProvider";
import { MeetingProvider } from "./src/context/MeetingProvider";
import { EmailProvider } from "./src/context/EmailProvider";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./src/theme";
// typeface-poppins removed: the brand font is Nunito Sans, vendored locally,
// and nothing referenced Poppins any more.

// IPC Wealth Design System (vendored, see src/design-system/VENDORED.txt).
// Link order is prescribed by docs/USING-THIS-SYSTEM.md and matters:
//   fonts -> tokens -> reset -> base
// The house layer loads last so its overrides win. It is kept outside
// src/design-system/ so re-vendoring a new version never clobbers it.
import "./src/design-system/type/fonts.css";
import "./src/design-system/tokens/tokens.css";
import "./src/design-system/css/reset.css";
import "./src/design-system/css/base.css";
import "./src/design-system/css/components.css";
import "./src/styles/ipc-house.css";

export const wrapRootElement = ({ element }) => {
  return (
    <ThemeProvider theme={theme}>
      <EmailProvider>
        <MeetingProvider>
          <LoadingProvider>{element}</LoadingProvider>
        </MeetingProvider>
      </EmailProvider>
    </ThemeProvider>
  );
};
